import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import design from "../../assets/images/design.png";
import ApiService from "../../services/ApiService";
import { useTranslation } from "react-i18next";

export default function OurTalents() {
  const [homeData, setHomeData] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const fetchHome = async () => {
    setIsLoading(true);
    try {
      const response = await ApiService.request({
        method: "GET",
        url: `/getHome`,
      });
      const data = response.data.data;
      setHomeData(data);
      if (data?.skills?.length > 0) {
        setActiveTab(data.skills[0].skill_title);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHome();
  }, []);

  const displayTalents =
    homeData?.skills?.find((skill) => skill.skill_title === activeTab)?.talents ||
    [];

    const imageSliderSettings = {
        dots: false,
        infinite: displayTalents.length > 4, // Only infinite if more than 4 items
        speed: 500,
        slidesToShow: Math.min(displayTalents.length, 4), // Never show more slides than available
        slidesToScroll: 1,
        centerPadding: "0px", 
        centerMode: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: Math.min(displayTalents.length, 3) } },
          { breakpoint: 768, settings: { slidesToShow: Math.min(displayTalents.length, 2) } },
          { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
      };
      
  return (
    <div className={`container px-3 px-md-0 position-relative ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`} id="talents">
      <div
        className={`top places-main p-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        style={{
          backgroundColor: "#411318",
          minHeight: "500px",
          borderRadius: "40px",
        }}
        id="places"
      >
        {/* Header + Tabs */}
        <div className={`d-flex flex-column flex-md-row justify-content-between align-items-center mb-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}>
          
          <div className={`bar mt-5 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}>
            <ul
              className={`d-flex flex-wrap gap-2 justify-content-center list-unstyled m-0 p-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ borderRadius: "50px" }}
            >
              {homeData?.skills?.map((tab, index) => (
                <li
                  key={tab.skill_id}
                  className={`fw-normal tabs-size d-flex justify-content-center align-items-center rounded-pill ${
                    index > 2 ? "d-none d-sm-block" : ""
                  } ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                  style={{
                    backgroundColor:
                      activeTab === tab.skill_title
                        ? "#fff"
                        : "rgb(98, 33, 40)",
                    color:
                      activeTab === tab.skill_title ? "#411318" : "#fff",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveTab(tab.skill_title)}
                >
                  {i18n.language === "ar"
                    ? tab.skill_title_ar || tab.skill_title
                    : tab.skill_title}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Slider */}
        <div className={`row g-4 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}>
        {isLoading ? (
    <p className="text-white text-center ">Loading...</p>
  ) : displayTalents.length > 0 ? (
    displayTalents.length > 1 ? (
      <div className="team-slider-wrapper">
      <Slider {...imageSliderSettings}>
        {displayTalents.map((talent) => (
          <div key={talent._id} className={` ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`} style={{maxWidth:"250px"}}>
            <div className={`text-center ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}>
            <div
      className={`rounded-circle overflow-hidden mx-auto mb-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
      // Fix: Use fixed width and height instead of maxWidth/maxHeight
      style={{ width: "250px", height: "250px" }}
    >
      <img
        src={talent.picture}
        alt={`${talent.first_name} ${talent.last_name}`}
        className={` ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        // Fix: Remove img-fluid, add display block and fixed sizing with object-fit
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
              <h6
                className={`text-white mb-0 talent-name-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  fontSize: "25px",
                  fontWeight: "400",
                }}
              >
                {talent.first_name} {talent.last_name}
              </h6>
              <small
                className={`text-white ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                }}
              >
                {i18n.language === "ar"
                  ? talent?.skill_id?.title_ar || talent?.skill_id?.title || ""
                  : talent?.skill_id?.title || ""}
              </small>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    ) : (
      <div className="d-flex justify-content-center">
        {displayTalents.map((talent) => (
          <div
            key={talent._id}
            className={`text-center mx-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            style={{ maxWidth: "250px" }}
          >
            <div
              className={`rounded-circle overflow-hidden mx-auto mb-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ width: "250px", height: "250px" }}
            >
              <img
        src={talent.picture}
        alt={`${talent.first_name} ${talent.last_name}`}
        className={` ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
        // Fix: Remove img-fluid, add display block and fixed sizing with object-fit
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
            </div>
            <h6
              className={`text-white mb-0 talent-name-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{
                fontSize: "25px",
                fontWeight: "400",
              }}
            >
              {talent.first_name} {talent.last_name}
            </h6>
            <small
              className={`text-white ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{
                fontSize: "18px",
                fontWeight: "400",
              }}
            >
              {i18n.language === "ar"
                ? talent?.skill_id?.title_ar || talent?.skill_id?.title || ""
                : talent?.skill_id?.title || ""}
            </small>
          </div>
        ))}
      </div>
    )
  ) : (
    <p className="text-white text-center">No talents available</p>
  )}
        </div>
      </div>

      {/* Decorative design image */}
      <div className={`design-i ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}>
        <img src={design} alt="design" />
      </div>
    </div>
  );
}
